import { render, staticRenderFns } from "./proreportsum.vue?vue&type=template&id=4305a112&scoped=true&"
import script from "./proreportsum.vue?vue&type=script&lang=js&"
export * from "./proreportsum.vue?vue&type=script&lang=js&"
import style0 from "./proreportsum.vue?vue&type=style&index=0&id=4305a112&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4305a112",
  null
  
)

export default component.exports